import { put, call } from 'redux-saga/effects'
import axios from 'axios'
import {
  LOGIN_START,
  LOGIN_ERROR,
  LOGIN_FINALLY,
  INIT_SAGAS,
} from '../../actions'

export default {
  Login: function* ({ payload: { email, password } }) {
    try {
      yield put(LOGIN_START())
      const { data: { token } } = yield call(axios.post, 'auth/local', {
        email,
        password,
      })
      yield put(INIT_SAGAS({ token }))
    } catch (error) {
      yield put(LOGIN_ERROR('El usuario y/o la contraseña son incorrectos.'))
    } finally {
      yield put(LOGIN_FINALLY())
    }
  },
  Logout: (history, localStorage) => () => {
      localStorage.clear()
      history.replace('/login')
  },
}
